<template>
<div></div>
</template>

<script>
export default {
  name: 'leftCenterHistory'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/leftCenterHistory.vue